module.exports = __webpack_public_path__ + "static/media/logo-coopt-black.629555c3.png";